
export default function DateInput({ identifier, min, max, mandatory, onChange, value, disabled }) {
    return (
        <input type="date"
            name={identifier}
            id={identifier}
            className={`date-input default-input ${mandatory ? "mandatory-input" : ""}`}
            min={min} max={max}
            required={mandatory}
            value={value}
            onChange={onChange ? onChange : undefined}
            disabled={disabled}
        ></input>
    );
}